export default __webpack_public_path__ + "static/media/fore-ellipse.b7f2f988.svg";